import { useFeatureFlags } from "@packsize/feature-flags";

export const useFeatureFlaggedValue = <T>(value: T, featureFlag: string, fallback: T | null = null): T | null => {
	const { isFeatureFlagEnabled } = useFeatureFlags();

	if (isFeatureFlagEnabled(featureFlag) !== true) {
		return fallback;
	}

	return value;
};
